import { MacrosResponse } from "@/clients/models/MacrosResponse";
import { NutritionalRequirementsService } from "@/clients/services/NutritionalRequirementsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

interface UseGetMacrosOptions {
  enabled?: boolean;
}

export const useGetMacros = (options?: UseGetMacrosOptions) => {
  const { data, isLoading, error } = useQuery({
    queryKey: [QueryKeys.NUTRITIONAL_REQUIREMENT, "macros"],
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const response =
        await NutritionalRequirementsService.getMacrosApiV1NutritionalRequirementsMacrosGet(
          user.id,
        );
      return response.data;
    },
    enabled: options?.enabled ?? true,
    staleTime: 0,
  });

  return {
    macros: data as MacrosResponse | undefined,
    isLoading,
    error,
  };
};
